var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stage',{ref:"stage",attrs:{"config":_vm.stageSize},on:{"mousedown":_vm.handleStageMouseDown}},[_c('v-layer',{ref:"layer"},[_c('v-shape',{attrs:{"name":"basic","config":{
        sceneFunc: function(context, shape) {
          context.beginPath();

          //context.stroke('red')
          context.moveTo(20, 100);
          context.lineTo(50, 10);

          //context.stroke('orange')
          context.moveTo(50, 10);
          context.lineTo(80, 50);

          //context.stroke('green')
          context.moveTo(80, 50);
          context.lineTo(150, 50);

          context.stroke('blue');
          context.moveTo(150, 50);
          context.lineTo(180, 100);

          // special Konva.js method
          context.fillStrokeShape(shape);
        },
        fill: 'blue',
        stroke: 'black',
        strokeWidth: 2
      }}}),_c('v-transformer',{ref:"transformer"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }